// extracted by mini-css-extract-plugin
export var component = "GridMenu-module--component--PojUC";
export var description = "GridMenu-module--description--IqfWq";
export var icon = "GridMenu-module--icon--HxRt2";
export var list = "GridMenu-module--list--fBnL2";
export var text = "GridMenu-module--text--H39r8";
export var title = "GridMenu-module--title--RMM-z";